import { IFormProps } from 'framework/forms/common/IFormProps';
import { FormSelectFieldFromRecord } from 'framework/forms/FormSelectFieldFromRecord';
import { LanguageOption, PatientLanguageOption } from 'gen/ApiClient';
import React, { useContext } from 'react';
import { RecordContext } from 'shared/records/RecordContext';

export const FormSelectLanguageField = <TModel extends unknown>({ ...props }: IFormProps<TModel>) => {
	const { localizedLanguageRecord } = useContext(RecordContext);

	return (
		<FormSelectFieldFromRecord<TModel, LanguageOption>
			{...props}
			record={localizedLanguageRecord}
		/>
	);
};

export const FormSelectPatientLanguageField = <TModel extends unknown>({ ...props }: IFormProps<TModel>) => {
	const { localizedPatientLanguageRecord } = useContext(RecordContext);

	return (
		<FormSelectFieldFromRecord<TModel, PatientLanguageOption>
			{...props}
			record={localizedPatientLanguageRecord}
		/>
	);
};
